<template><div><h1>VUX V2.6.0 发布日志</h1>
<h2><a href="/zh-CN/components/calendar.html">Calendar</a></h2>
<ul><li>[feature] 支持显示弹窗头部(取消，确定)</li>
</ul>
<h2><a href="/zh-CN/components/checker.html">Checker</a></h2>
<ul><li>[fix] 修复 on-change 事件 在使用 :value 绑定的情况下不触发 #1945</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] 修复取消文字、确认文字国际化显示问题</li>
</ul>
<h2><a href="/zh-CN/components/grid.html">Grid</a></h2>
<ul><li>[change] rows 属性已经废弃，使用自动计算 #1971</li>
</ul>
<h2><a href="/zh-CN/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[feature] (beta) 支持属性 marks 用以自定义特定日期显示样式</li>
<li>[fix] 修复星期文字 i18n</li>
</ul>
<h2><a href="/zh-CN/components/load-more.html">LoadMore</a></h2>
<ul><li>[fix] 修复 `tip` 为空，且 `show-loading` 为 `false` 时背景颜色不对的问题 </li>
<li>[feature] 支持 @load-more-tip-background-color 全局设置文字背景颜色</li>
</ul>
<h2><a href="/zh-CN/components/panel.html">Panel</a></h2>
<ul><li>[enhance] 支持列表 fallbackSrc 属性在图片加载失败后显示 #1923</li>
</ul>
<h2><a href="/zh-CN/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[fix] 修复 placeholder 显示逻辑 #1964</li>
</ul>
<h2><a href="/zh-CN/components/swiper.html">Swiper</a></h2>
<ul><li>[enhance] 支持 list.fallbackImg 属性在图片加载失败时显示预设图片 #1923</li>
</ul>
<h2><a href="/zh-CN/components/x-dialog.html">XDialog</a></h2>
<ul><li>[fix] 修复弹窗滑动时 body 区域依然会滚动的问题</li>
</ul>
<h2><a href="/zh-CN/components/x-img.html">XImg</a></h2>
<ul><li>[fix] 当 src 变化时重新初始化 #1901</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.6.0 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.6.0-253.vue?3ff30e1c